import { render, staticRenderFns } from "./CustomerAddView.vue?vue&type=template&id=6b55c2ec"
import script from "./CustomerAddView.vue?vue&type=script&lang=js"
export * from "./CustomerAddView.vue?vue&type=script&lang=js"
import style0 from "./CustomerAddView.vue?vue&type=style&index=0&id=6b55c2ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports